<template>
  <span>
    <div class="page-level-functions">
      <router-link to="/roles/new">
        <action-button
          variant="success float-right ml-3"
          text="Añadir"
          i="fas fa-plus-square"
        />
      </router-link>
      <router-link to="/">
        <action-button
          variant="outline-success float-right ml-3"
          text="Regresar"
          i="fas fa-arrow-circle-left"
        />
      </router-link>
    </div>
    <hr class="page-level-functions-separator" />
    <div class="sub-content-wrapper">
      <search-criteria-entry @searchClicked="applyFilters">
        <div class="col-md-6 col-sm-12">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text input-icon">
                <em class="fas fa-lg fa-search" />
              </span>
            </div>
            <input
              ref="filterInput"
              type="text"
              class="form-control filter-input"
              :placeholder="searchCriteria.filterText.placeholder"
              :maxlength="searchCriteria.filterText.maxlength"
              v-model="model.searchText"
            />
          </div>
        </div>
        <div class="col-md-6 col-sm-12 mt-2 mt-md-0 mt-sm-2">
          <custom-drop-down
            fieldkey="id"
            fieldname="name"
            :placeholder="searchCriteria.appId.placeholder"
            :options="searchCriteria.appId.options"
            v-model="model.application"
          />
        </div>
      </search-criteria-entry>
      <div class="row mt-3">
        <custom-title-divider
          title="Información de los Roles"
        ></custom-title-divider>
      </div>
      <div class="mx-n3">
        <result-not-found v-if="result.data.length === 0" />
        <div v-for="(row, index) in result.data" :key="`row-app-${index}`">
          <callout class="my-3" :has-toggle="false">
            <div class="row my-0">
              <div class="col-md-10">
                <div class="row mt-2">
                  <div class="col-md-1 d-flex align-items-center mr-n4">
                    <em class="fas fa-2x fa-user-cog align-middle row-icon" />
                  </div>
                  <div class="col-md-4">
                    <div class="color-secondary-6 font-16">Nombre</div>
                    <div class="color-black font-16 font-weight-normal">
                      {{ row.roleName }}
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="color-secondary-6 font-16">Descripción</div>
                    <div class="color-black font-16 font-weight-normal">
                      {{ row.roleDescription }}
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="color-secondary-6 font-16">Aplicación</div>
                    <div class="color-black font-16 font-weight-normal">
                      {{ row.applicationNames }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-2 d-flex justify-content-end align-items-center pr-5"
              >
                <router-link :to="'/roles/' + row.roleId">
                  <action-button
                    variant="outline-success enter-button mr-2"
                    text="Entrar"
                    i="fas fa-sign-in-alt"
                    min-width="100px"
                  />
                </router-link>
              </div>
            </div>
          </callout>
        </div>
        <pagination
          v-if="showPagination"
          :show-text="true"
          @pagination-go-page="goToPageHandler"
          :data="result.pagination"
        />
      </div>
    </div>
  </span>
</template>

<script>
import SearchCriteriaEntry from '@/components/common/SearchCriteriaEntry'
import { getApplicationsList } from '@/modules/applications/api'
import { getRolesSearchResults } from '@/modules/roles/api'
import CustomTitleDivider from '@/components/common/CustomTitleDivider'
import ActionButton from '@/components/common/ActionButton'
import {} from '@/mixins/vue-alerts'
import { mapGetters, mapActions } from 'vuex'
import { name as rolesModuleName } from '@/modules/roles/store'
import Callout from '@/components/common/callout/View'
import ResultNotFound from '@/components/common/ResultNotFound'
import Pagination from '@/components/common/Pagination'
import CustomDropDown from '@/components/common/form/CustomDropDown'
import storeMixin from '@/mixins/storeGenerator';

const initialSearchState = () => ({
  searchText: null,
  application: null,
});

const initialResultState = () => ({
  data: [],
  pagination: {
    totalItemCount: 0,
    count: 15,
    pageCount: 0,
    currentPage: 1,
  },
});

export default {
  name: 'RoleSearch',
  components: {
    SearchCriteriaEntry,
    CustomTitleDivider,
    ActionButton,
    Callout,
    ResultNotFound,
    Pagination,
    CustomDropDown,
  },
  mixins: [storeMixin],
  data() {
    return {
      searchCriteria: {
        filterText: {
          placeholder: 'Escriba Nombre de Rol o Descripción',
          maxlength: 100,
        },
        appId: {
          placeholder: 'Seleccione Aplicación',
          options: [],
        },
      },
      result: initialResultState(),
      model: initialSearchState(),
    }
  },
  computed: {
    ...mapGetters(rolesModuleName, ['affectedRoleData']),
    showPagination() {
      return (
        this.result.data.length > 0 &&
        this.result.pagination.totalItemCount > this.result.pagination.count
      )
    },
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (from.name == 'home') {
        vm.shouldRecovery = false;
        vm.model = initialSearchState();
        vm.result = initialResultState();
      } else vm.recoveryData();

      vm.callGetResult(vm.result.pagination.currentPage);
    });
  },
  async created() {
    this.searchCriteria.appId.options = await getApplicationsList()
    if (this.affectedRoleData) {
      const verb = this.getAction(this.affectedRoleData.operation);
      this.Toast('Aviso', 'El rol fue ' + verb + ' exitosamente.', 'success')
      this.setAffectedApplicationData(null)
    }
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    ...mapActions(rolesModuleName, ['setAffectedRoleData']),
    getAction(action) {
      switch (action) {
        case 'I':
          return 'creada'
        case 'U':
          return 'actualizada';
        default:
          return '???'; //ECG:No se que le hiciste al user! :P
      }
    },
    applyFilters() {
      this.callGetResult()
    },
    async callGetResult(pageNumber = 1) {
      const payload = {
        filterCriteria: this.model.searchText ?? null,
        appId: this.model.application?.id ?? null,
        pageNumber,
        pageSize: this.result.pagination.count,
      }
      const { data } = await getRolesSearchResults(payload)
      this.result = {
        ...this.result,
        data: data.data,
        pagination: {
          ...this.result.pagination,
          currentPage: pageNumber,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
        },
      }
    },
    goToPageHandler(page) {
      this.callGetResult(page)
    },
  },
}
</script>

<style scoped>
.enter-button {
  background-color: transparent;
  float: right;
}
.row-icon {
  color: #ff7058;
}
</style>
